import * as React from 'react';

function Chevron(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={17} height={10} fill="none" {...props}>
      <path
        d="M7.736 8.639L1.361 2.264a1.024 1.024 0 010-1.494 1.024 1.024 0 011.494 0L8.5 6.38 14.111.77a1.024 1.024 0 011.494 0 1.024 1.024 0 010 1.494L9.23 8.639a1.024 1.024 0 01-1.494 0z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoChevron = React.memo(Chevron);
export default MemoChevron;
